// 顧客宛文書一覧
import { SearchParams, Status } from '../types/CustomerDocumentList';

// 検索条件-日付検索項目
export const date_search_target = [
  { key: '', value: '' },
  { key: '1', value: '掲載開始日' },
  { key: '2', value: '掲載終了日' },
  { key: '3', value: '直近更新日' },
];

// 検索条件-日付検索方法
export const date_search_type = [
  { key: '', value: '' },
  { key: '1', value: '完全一致' },
  { key: '2', value: '以降の日付' },
  { key: '3', value: '以前の日付' },
];

// 検索条件-検索項目
export const search_target = [
  { key: '', value: '' },
  { key: '1', value: 'タイトル' },
  { key: '2', value: 'ファイル名' },
  { key: '3', value: '顧客名' },
  { key: '4', value: 'メールアドレス' },
  { key: '5', value: '登録者' },
  { key: '6', value: '承認者' },
  { key: '7', value: 'ステータス' },
];

// 検索条件-検索方法
export const search_type = [
  { key: '', value: '' },
  { key: '1', value: '完全一致' },
  { key: '2', value: '部分一致' },
];

// 検索条件パラメータ-初期値
export const search_params_init: SearchParams = {
  date_search: {
    target: null,
    item: '',
    type: ''
  },
  search: {
    target: '',
    item: '',
    type: ''
  },
};

// 顧客宛文書のステータス
export const customer_document_status = [
  { id: '1', value: '未承認' },
  { id: '2', value: '承認済み' },
  { id: '3', value: '掲載中' },
  { id: '4', value: '掲載終了' },
  { id: '5', value: '削除承認待ち' },
  { id: '6', value: '削除済み' }
];

// MDBDataTableのカラム設定
export const datatable_columns = [
  {
    label: 'タイトル',
    field: 'title',
    sort: 'asc',
    width: 360,
  },
  {
    label: 'ファイル名',
    field: 'filename',
    sort: 'asc',
    width: 280,
  },
  {
    label: '顧客名',
    field: 'user_name',
    sort: 'asc',
    width: 160,
  },
  {
    label: 'メールアドレス',
    field: 'email',
    sort: 'asc',
    width: 240,
  },
  {
    label: '掲載開始日',
    field: 'start_date',
    sort: 'asc',
    width: 160,
  },
  {
    label: '掲載終了日',
    field: 'end_date',
    sort: 'asc',
    width: 160,
  },
  {
    label: '登録者',
    field: 'registered_person',
    sort: 'asc',
    width: 160,
  },
  {
    label: '承認者',
    field: 'authorizer',
    sort: 'asc',
    width: 160,
  },
  {
    label: 'ステータス',
    field: 'status',
    sort: 'asc',
    width: 160,
  },
  {
    label: '直近更新日',
    field: 'updated_at',
    sort: 'asc',
    width: 160,
  },
  {
    label: '詳細',
    field: 'detail',
    sort: 'asc',
    width: 90,
  },
];

export const status: Status = {
  1: '未承認',
  2: '承認済み',
  3: '掲載中',
  4: '掲載終了',
  5: '削除承認待ち',
  6: '削除済み',
};

// APIレスポンスのモック
// TODO APIが実装され不要になった時点で削除する
export const mockKWANKGM10050A02 = {
  data: {
    result: true,
    message: '',
    list: [
      {
        id: 1,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 2,
        title: 'モックファイル2',
        file_name: 'mock_file2.txt',
        user_list: [
          {
            user_name: '顧客名2a',
            email: 'kokyaku2a@example.com',
          },
          {
            user_name: '顧客名2b',
            email: 'kokyaku2b@example.com',
          },
          {
            user_name: '顧客名2c',
            email: 'kokyaku2c@example.com',
          },
        ],
        start_date: '2021-09-28',
        end_date: '2021-09-29',
        create_user_name: '登録者2',
        authorizer_name: '承認者2',
        status: 2,
        update_at: '2021-09-30'
      },
      {
        id: 3,
        title: '長いファイル名１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０',
        file_name: 'mock_file2_long_file_name_123456789012345678901234567890.txt',
        user_list: [
          {
            user_name: '顧客名3',
            email: 'kokyaku3@example.com',
          },
        ],
        start_date: '2020-09-28',
        end_date: '2020-09-29',
        create_user_name: '登録者3',
        authorizer_name: '承認者3',
        status: 3,
        update_at: '2020-09-30'
      },
      {
        id: 4,
        title: '長いファイル名123456789012345678901234567890',
        file_name: '日本語のファイル名１２３４５６７８９０１２３４５６７８９０.txt',
        user_list: [
          {
            user_name: '顧客名4',
            email: 'kokyaku4@example.com',
          },
        ],
        start_date: '2019-09-28',
        end_date: '2019-09-29',
        create_user_name: '登録者4',
        authorizer_name: '承認者4',
        status: 4,
        update_at: '2019-09-30'
      },
      {
        id: 5,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 5,
        update_at: '2022-09-30'
      },
      {
        id: 6,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 6,
        update_at: '2022-09-30'
      },
      {
        id: 7,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 8,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 9,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 10,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 11,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 12,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 13,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 14,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 15,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 16,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 17,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 18,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 19,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 20,
        title: 'モックファイル1',
        file_name: 'mock_file1.txt',
        user_list: [
          {
            user_name: '顧客名1',
            email: 'kokyaku1@example.com',
          },
        ],
        start_date: '2022-09-28',
        end_date: '2022-09-29',
        create_user_name: '登録者1',
        authorizer_name: '承認者1',
        status: 1,
        update_at: '2022-09-30'
      },
      {
        id: 21,
        title: 'モックファイル21',
        file_name: 'mock_file21.txt',
        user_list: [
          {
            user_name: '顧客名21',
            email: 'kokyaku21@example.com',
          },
        ],
        start_date: '2122-09-28',
        end_date: '2122-09-29',
        create_user_name: '登録者21',
        authorizer_name: '承認者21',
        status: 2,
        update_at: '2122-09-30'
      },
    ],
    detail: [
      {
        "form_name": "date_search.target",
        "message": "日付検索項目は必須です"
      },
      {
        "form_name": "date_search.item",
        "message": "検索年月日は必須です"
      },
      {
        "form_name": "date_search.type",
        "message": "日付検索方法は必須です"
      },
      {
        "form_name": "search.target",
        "message": "検索項目は必須です"
      },
      {
        "form_name": "search.item",
        "message": "検索内容は必須です"
      },
      {
        "form_name": "search.type",
        "message": "検索方法は必須です"
      },
    ]
  },
};

// エラーメッセージの初期化
export const init_error_message = {
  date_search_target: '', // 検索年月日
  date_search_item: '', // 日付検索項目
  date_search_type: '', // 日付検索方法
  search_target: '', // 検索内容
  search_item: '', // 検索項目
  search_type: '', // 検索方法
};
